/* ==========================================================================
   Story Bounce Shared JavaScript
   Reusable behaviours for all custom Story Bounce sections.
   ========================================================================== */

(() => {
  const SELECTOR = '.sb-flip-cards';

  function initialiseFlipCards(root = document) {
    root.querySelectorAll(SELECTOR).forEach((section) => {

      // Prevent duplicate initialisation
      if (section.dataset.sbInitialised === 'true') return;
      section.dataset.sbInitialised = 'true';

      section.querySelectorAll('[data-flip-card]').forEach((card) => {

        const buttons = card.querySelectorAll('[data-flip-toggle]');
        const faces = card.querySelectorAll('.sb-flip-card__face');

        function setState(flipped) {
          card.classList.toggle('is-flipped', flipped);

          buttons.forEach((button) => {
            button.setAttribute('aria-expanded', flipped);
          });

          if (faces.length === 2) {
            faces[0].setAttribute('aria-hidden', flipped);
            faces[1].setAttribute('aria-hidden', !flipped);
          }
        }

        buttons.forEach((button) => {
          button.addEventListener('click', function (e) {
            e.stopPropagation();
            setState(!card.classList.contains('is-flipped'));
          });
        });

        // Optional: click anywhere on the card
        if (section.dataset.cardClick === 'true') {

          card.addEventListener('click', function (e) {

            if (
              e.target.closest('a') ||
              e.target.closest('button') ||
              e.target.closest('input') ||
              e.target.closest('textarea') ||
              e.target.closest('select')
            ) {
              return;
            }

            setState(!card.classList.contains('is-flipped'));

          });

        }

      });

    });
  }

  // Initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseFlipCards();
    });
  } else {
    initialiseFlipCards();
  }

  // Shopify Theme Editor support
  document.addEventListener('shopify:section:load', function (event) {
    initialiseFlipCards(event.target);
  });

})();